import { Animations } from '@enums/Animations'
import { useEffect, useRef, useState } from 'react'

type useAnimateOnVisibleOptions = {
  threshold?: number
  everyInteraction?: boolean
  animation?: Animations
  animationDelayMs?: number
}

// TODO: need reverse animation on every interaction

export const useAnimateOnVisible = <T extends HTMLElement = HTMLElement>({
  threshold = 0.3,
  everyInteraction = false,
  animation = Animations.FadeIn,
  animationDelayMs,
}: useAnimateOnVisibleOptions = {}) => {
  const ref = useRef<T | null>(null)
  const [isVisible, setIsVisible] = useState(false)
  const [hasObserved, setHasObserved] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        setHasObserved(true)

        if (entry.isIntersecting) {
          setIsVisible(true)
          if (!everyInteraction) observer.unobserve(entry.target)
        } else if (everyInteraction) setIsVisible(false)
      },
      { threshold }
    )

    observer.observe(el)

    return () => observer.disconnect()
  }, [threshold, everyInteraction])

  const animationClassName = `${animation}${isVisible ? '-animate' : '-initial'}`
  const el = ref.current
  if (el && animationDelayMs) {
    el.style.animationDelay = `${animationDelayMs}ms`
  }

  return { ref, isVisible, hasObserved, animationClassName }
}
